var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"white radius-15"},[_c('job-experience',{attrs:{"isComplete":true}}),_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.$emit('nextHandler',3)}}},[_c('dialog-btns',{attrs:{"btnTitle":_vm.$t('forms.saveContinue'),"closeTitle":''}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }